export const REVENUE_SOURCE_MAP = {
  VAT_INVOICE: { label: "VAT", bg: "primary" },
  NORMAL_INVOICE: { label: "Line thường", bg: "success" },
  MANUAL_VOUCHER: { label: "Phiếu thủ công", bg: "info" },
  MIXED: { label: "Mixed", bg: "secondary" },
};

export const EXPENSE_SOURCE_MAP = {
  PARTNER_NORMAL: { label: "Đối tác thường", bg: "primary" },
  PARTNER_VAT: { label: "Đối tác VAT", bg: "info" },
  MANUAL_VOUCHER: { label: "Phiếu thủ công", bg: "info" },
  MIXED: { label: "Mixed", bg: "secondary" },
};

/** Nguồn công nợ phải thu (đối soát khách hàng). */
export const RECEIVABLE_SOURCE_MAP = {
  NORMAL_INVOICE: { label: "ĐS KH Thường", bg: "success" },
  VAT_INVOICE: { label: "ĐS KH VAT", bg: "primary" },
  TTH_RECONCILIATION: { label: "ĐS TTH", bg: "warning" },
  MANUAL_VOUCHER: { label: "Tạo thủ công", bg: "info" },
};

/** Nguồn công nợ phải trả (đối soát đối tác). */
export const PAYABLE_SOURCE_MAP = {
  PARTNER_NORMAL: { label: "ĐS ĐT Thường", bg: "primary" },
  PARTNER_VAT: { label: "ĐS ĐT VAT", bg: "info" },
  MANUAL_VOUCHER: { label: "Tạo thủ công", bg: "secondary" },
};

export const resolveSourceLabel = (sourceType, map) =>
  map[sourceType]?.label || sourceType || "—";

/**
 * Format một hoặc nhiều sourceType (CSV từ GROUP_CONCAT) thành nhãn hiển thị.
 * VD: "PARTNER_NORMAL,PARTNER_VAT" → "ĐS ĐT Thường, ĐS ĐT VAT"
 */
export const formatDebtSourceLabels = (sourceType, map) => {
  if (!sourceType) return "";
  const parts = String(sourceType)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length === 0) return "";
  return parts.map((p) => map[p]?.label || p).join(", ");
};

export const debtSourceBadgeBg = (sourceType, map) => {
  if (!sourceType) return "secondary";
  const first = String(sourceType).split(",")[0].trim();
  return map[first]?.bg || "secondary";
};
